<template>
  <div class="page">
    <div id="content">
      <div id="products">
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Weapon-And-Tools/diamond-axe.png" alt="Diamond Pickaxe">
          <h2 class="title">Diamond Pickaxe</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Diamond/diamond-emerald.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Ruby/ruby-gold-ruby.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Ranks-Avatars/Prestieges/Prestigios/Prestigio-Redstonte.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product large" @mouseenter="playSound()" @click="$router.push(`${$route.params.page}/p90-grim`)">
          <img src="/img/72db38a2d6e4c9cd5179f1aad3b929ef.png" alt="P90 Grim">
          <h2 class="title">P90 Grim</h2>
          <h2 class="price">€ 12.95</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Iron/iron-gold-diamond.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/Chest.gif" alt="Mystery Chest">
          <h2 class="title">Mystery Chest</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Ruby/ruby-gold-ruby.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product large" @mouseenter="playSound()">
          <img src="/img/vector-ak47-gold-3.png" alt="Vector AK-47 Gold">
          <h2 class="title">Vector AK-47 Gold</h2>
          <h2 class="price">€ 24.99</h2>
        </div>
        <div class="product large" @mouseenter="playSound()">
          <img src="/img/1522617693_preview_SG 553 Pulse.png" alt="SG 553 Pulse">
          <h2 class="title">SG 553 Pulse</h2>
          <h2 class="price">€ 24.99</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Ranks-Avatars/Prestieges/Prestigios/Prestigio-Redstonte.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product large" @mouseenter="playSound()">
          <img src="/img/tebex/Items/Potions/4.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Iron/iron-gold-diamond.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Preresized-Icon-Package/Keys/Diamond/diamond-emerald.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/EnchantedBookNew.webp" alt="Enchanted book">
          <h2 class="title">Enchanted book</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product" @mouseenter="playSound()">
          <img src="/img/tebex/Ranks-Avatars/Prestieges/Prestigios/Prestigio-Redstonte.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
        <div class="product large" @mouseenter="playSound()">
          <img src="/img/1484678514_preview_s422.png" alt="Elite Rank">
          <h2 class="title">Iron Rank</h2>
          <h2 class="price">€ 7.50</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howl } from 'howler'
import * as VanillaTilt from 'vanilla-tilt'

export default {
  mounted () {
    VanillaTilt.init(document.querySelectorAll('.product'), {
      // scale: 1,
      max: 12,
      speed: 300,
      perspective: 1000,
      reverse: false
    })
  },
  methods: {
    playSound () {
      const sound = new Howl({
        src: ['./audio/little_tech_10.mp3'],
        autoplay: true,
        loop: false,
        volume: 0.2
      })
    },
    playBuySound () {
      const sound = new Howl({
        src: ['./audio/PM_FN_Events_LvlUps_PowerUps_30.wav'],
        autoplay: true,
        loop: false,
        volume: 0.5
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  // overflow-x: hidden;

  #content {
    width: 100%;

    #products {
      width: 100%;
      padding: 20px;
      padding-top: unset;
      padding-right: unset;
      display: flex;
      flex-wrap: wrap;

      .product {
        position: relative;
        flex: 1 0 calc(25% - (20px * 3));
        cursor: pointer;
        user-select: none;
        padding: 30px;
        margin-top: 20px;
        margin-right: 20px;
        min-width: 175px;
        max-width: calc(600px - 20px);
        height: 300px;
        border-radius: 48px;
        // border: 5px solid rgba(#fff, .075);
        // box-shadow: inset 0 0 100px 0px rgba(#000, .15);
        background-color: rgba(#fff, .075);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        transform-style: preserve-3d;
        text-align: center;
        transition-property: transform !important;
        // transform: perspective(1000px);

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 48px;
          // background-color: rgba(#fff, .12);
          border: 4px solid rgba(#fff, .15);
          opacity: 0;
          // transition: .15s opacity;
        }

        &:hover {
          background: unset;
          &::after {
            opacity: 1;
          }
          img {
            opacity: 1;
            transform: translateZ(80px) scale(1.15);
            filter: drop-shadow(10px 20px 15px rgba(#000, .3));
            animation: scale-up .1s ease-out;

            @keyframes scale-up {
              0% {
                filter: drop-shadow(2px 4px 3px rgba(#000, .3));
                transform: translateZ(80px);
              }
              100% {
                filter: drop-shadow(10px 20px 15px rgba(#000, .3));
                transform: translateZ(80px) scale(1.15);
              }
            }
          }
        }

        &.large {
          flex: 1 0 calc(50% - 20px);
        }

        img {
          transform: translateZ(80px);
          object-fit: contain;
          object-position: center;
          height: 60%;
          margin-bottom: 30px;
          // filter: drop-shadow(2px 4px 3px rgba(#000, .3));
          opacity: .75;
          animation: scale-down .1s ease-out;

          @keyframes scale-down {
            0% {
              filter: drop-shadow(10px 20px 15px rgba(#000, .3));
              transform: translateZ(80px) scale(1.15);
            }
            100% {
              filter: drop-shadow(2px 4px 3px rgba(#000, .3));
              transform: translateZ(80px);
            }
          }

          // animation: hover 3s ease-in-out infinite;

          // @keyframes hover {
          //   0% {
          //     transform: translateY(-5px) translateZ(80px);
          //   }
          //   50% {
          //     transform: translateY(5px) translateZ(80px);
          //   }
          //   100% {
          //     transform: translateY(-5px) translateZ(80px);
          //   }
          // }
        }

        .title {
          font-style: italic;
          transform: translateZ(40px);
          font-weight: 600;
          color: #fff;
        }

        .price {
          // font-style: italic;
          font-size: 24px;
          transform: translateZ(40px);
          font-weight: 600;
          color: rgba(#fff, .5);
        }

        &::last-child {
          margin-right: unset;
        }
      }
    }
  }
}
</style>
